import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export function BusinessProcess() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

